import axios from 'axios'
import Cookies from 'js-cookie'

export function Url() {
  return getUrl()
}

function getUrl() {
  var url = ''
  //   AIzaSyAXDfHT7HAAt_EZ0mFPGw6sVovzDeNogyM
  if (location.href.includes('localhost')) {
    url = 'https://staging.line.gladmobile.com'
  } else if (location.href.includes('staging.backstage.gladmobile.com')) {
    url = 'https://staging.line.gladmobile.com'
  } else if (location.href.includes('daisuki.backstage.gladmobile.com')) {
    url = 'https://daisuki.line.gladmobile.com'
  } else if (location.href.includes('backstage.gladmobile.com')) {
    url = 'https://daisuki.line.gladmobile.com'
  } else {
    url = 'https://staging.line.gladmobile.com'
  } //
  return url
}



// WEBPACK FOOTER //
// ./src/assets/js/libs/LineUrl.js